import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { get } from "common/helpers/HTTP";

import type { ApiToken } from "../types";

async function getApiTokens(workspaceId: string): Promise<ApiToken[]> {
  return (await get(`workspaces/${workspaceId}/tokens`)).tokens;
}

export default function useApiTokens() {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const {
    data: tokens,
    isLoading: isLoadingTokens,
    error: tokensError,
    refetch: refetchTokens,
  } = useQuery<ApiToken[]>({
    queryKey: ["apiTokens"],
    queryFn: () => getApiTokens(workspaceId),
  });

  return {
    tokens,
    isLoadingTokens,
    tokensError,
    refetchTokens,
  };
}
